import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get, find } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { push } from 'connected-react-router'
import { compose } from 'recompose'

import { notification, modal } from 'redux/modules/app'
import { fetchAwardSuccess } from 'redux/modules/api/dashboard/awards'
import { awards as awardsApi } from 'redux/modules/api/combineDashboard'
import { blob as blobApi } from 'redux/modules/api'
import { schemaApproval } from 'models/approvals'
import { uploadFilesSchema } from 'models/awards'
import { getActiveAwardId } from 'helpers/getActiveAward'
import {
  ACTIVITY_STATES,
  DELIVERY_TYPES,
  PAYMENT_STATES,
  PAYMENT_TYPES,
  AWARD_STATES
} from 'constants/enums'
import MODALS from 'constants/layout/modals'
import enhanceAwards from 'redux/selectors/dashboard/awards/enhancedAwards'
import configFile from 'config'

function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      withRouter,
      connect(
        ({ api, auth }) => ({
          awards: enhanceAwards(get(api, 'dashboard.awards.awards')),
          awardFiles: get(api, 'dashboard.awards.files'),
          leader: get(api, 'dashboard.awards.leader'),
          user: get(auth, 'user')
        }),
        {
          ...awardsApi,
          notification,
          modal,
          push,
          putBlob: blobApi.putBlob,
          fetchAwardSuccess
        }
      )
    )

    class apiAwardsDashboard extends Component {
      static propTypes = {
        awards: PropTypes.object,
        sendAwardApprovalRequest: PropTypes.func.isRequired,
        awardId: PropTypes.number,
        startNewLevel: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        loadAward: PropTypes.func.isRequired,
        loadFiles: PropTypes.func.isRequired,
        putBlob: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        match: PropTypes.object,
        fetchAward: PropTypes.func.isRequired,
        uploadAwardFiles: PropTypes.func.isRequired,
        deleteAwardFiles: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        fetchAwardSuccess: PropTypes.func,
        intl: PropTypes.object
      }

      static defaultProps = {
        match: {
          params: {}
        }
      }

      state = {
        blockedNotified: false
      }

      async componentDidMount() {
        const { awards, match } = this.props
        const { params } = match

        let currAward = null

        if (config.loadAward) {
          if (get(params, 'awardId')) {
            await this.props.fetchAward(params.awardId)
          }
          if (!awards.loaded) {
            await this.handleLoadAward()
          }

          currAward = this.getCurrentAward(awards)
//          await this.props.fetchAwardSuccess(currAward)
        }

        config.loadFiles && this.handleLoadFiles(get(params, 'awardId'))

        await this.handleRedirect(currAward)

        if (config.checkParentalConsent) {
          const isMissingParental = this.checkParentalConsent(currAward)

          if (isMissingParental) {
            // Dont check for payment if parental is already missing
            return
          }
        }

        config.checkIfPaid && this.checkIfPaid(currAward)
      }

      componentWillReceiveProps = async(nextProps) => {
        const { match, awards } = this.props
        const { params } = match

        if (params && params.awardId && params.awardId !== get(nextProps, 'match.params.awardId')) {
          config.fetchAward &&
          await this.props
            .fetchAward(nextProps.match.params.awardId)
            .then(({ body }) => this.handleRedirect(body))
        }

        if (awards.loaded
          && (config.checkIfPaid || config.checkParentalConsent)
        ) {
          const currAward = this.getCurrentAward(awards)
          const nextCurrAward = this.getCurrentAward(nextProps.awards)

          if (get(nextCurrAward, 'isBlocked') && !this.state.blockedNotified) {
            this.notifyBlockedAward(currAward)
          }
        }
      }

      checkIfPaid = award => {
        const paymentType = get(
          award,
          'participantRegistration.awardPayment.originPaymentType.value'
        )
        const paymentStatus = get(award, 'paymentState.value')

        const awardState = get(award, 'awardState.value')

        // if award is in higher state than assignment and approval (e.g. setup), then the award is approved and it is no
        // longer need to check if award is payed
        const isApproved = awardState !== AWARD_STATES.reg_assignment.id && awardState !== AWARD_STATES.reg_approval.id

        let missingPayment =
          paymentStatus === PAYMENT_STATES.notPaid.id &&
          (paymentType === PAYMENT_TYPES.online.id ||
            paymentType === PAYMENT_TYPES.payPal.id ||
            paymentType === PAYMENT_TYPES.globalPayments.id ||
            paymentType === PAYMENT_TYPES.globalPaymentsWebpay.id)

        missingPayment = missingPayment && !isApproved

        missingPayment &&
        this.props.modal(MODALS.REGISTRATION_INFO, null, {
          missingPayment: true,
          paymentType,
          authCode: get(
            award,
            'participantRegistration.onlinePaymentAuthorizationCode'
          )
        })

        return missingPayment
      }

      checkParentalConsent = award => {
        const missingParentalConsent =
          // If it's required and not confirmed, don't care about migrated
          get(award, 'migrationDate') === null &&
          ![null, undefined, DELIVERY_TYPES.NOT_REQUIRED.value].includes(
            get(award, 'consentDeliveryType.value')
          ) &&
          get(award, 'isConsentDeliveryConfirmed') === false

        missingParentalConsent &&
        this.props.modal(MODALS.REGISTRATION_INFO, null, {
          missingParentalConsent: true
        })

        return missingParentalConsent
      }

      getCurrentAward = awards => {
        const { params } = this.props

        const awardRes = awards.list

        return get(params, 'awardId') && awardRes && awardRes.length > 1
          ? awardRes.find(award => award.id === Number(params.awardId))
          : (awardRes && awardRes[0]) || {}
      }

      handleLoadAward = () =>
        this.props
          .loadAward()
          .then(({ body } = {}) => {
            if (!get(this.props, 'match.params.awardId')) {
              this.props.push(`${configFile.publicPath}/dashboard/awards/${getActiveAwardId(body)}`)
            }
            return body
          })
          .catch(this.handleError)

      handleRedirect = awards => {
        const { match } = this.props
        const { params } = match

        if (!awards) {
          return
        }

        let route = `${configFile.publicPath}/dashboard/awards/${get(params, 'awardId') || awards.id}`

        const activeActivity =
          awards.activities &&
          find(
            awards.activities,
            activity =>
              activity.activityState.value !== ACTIVITY_STATES.setup.id
          )

        this.props.push(route)
      }

      handleLoadFiles = awardId => {
        this.props.loadFiles(awardId)
      }

      handleSendLeaderRequest = (id, fields, { resetForm }) =>
        this.props
          .sendAwardApprovalRequest(id, schemaApproval(fields))
          .then(() =>
            this.handleSuccess(
              'Award approval request has been sent to your leader',
              'notifications.award_approval_request_sent_to_leader',
              { resetForm }
            )
          )
          .catch(this.handleError)

      handleStartNewLevel = (id, { resetForm }) =>
        this.props
          .startNewLevel(id)
          .then(res => {
            this.handleSuccess(
              'New level has started.',
              'notifications.new_level_has_started',
              { resetForm }
            )
            return res
          })
          .catch(this.handleError)

      handleUploadAwardFiles = (awardId, fields, sectionId, category) => {
        if (!fields.file) {
          return
        }

        this.props
          .putBlob({
            blob: fields.file,
            fileName: fields.file.name
          })
          .then(({ body = {} }) => {
            this.props
              .uploadAwardFiles(
                awardId,
                uploadFilesSchema(fields, body.url, sectionId, category)
              )
              .then(() => {
                this.handleSuccess(
                  'File has been uploaded',
                  'notifications.file_has_been_uploaded',
                  { awardId }
                )
              })
              .catch(this.handleError)
          })
          .catch(this.handleError)
      }

      handleDeleteAwardFile = ({ awardId, awardFileId }) => {
        this.props
          .deleteAwardFiles(awardId, awardFileId)
          .then(() => {
            this.handleSuccess(
              'File has been removed',
              'notifications.file_has_been_removed',
              { awardId }
            )
          })
          .catch(this.handleError)
      }

      handleSuccess = (
        text = 'Success',
        intlKey = 'notifications.success',
        options = {}
      ) => {
        const { match } = this.props
        const { params } = match

        this.props.notification(text, { status: 'success', intlKey })
        this.props.modal(null, null)
        this.handleRefreshAward()
        options.resetForm && options.resetForm()
        config.loadFiles && this.handleLoadFiles(get(params, 'awardId'))
      }

      handleError = err => {
        console.debug('error', err.body && err.body.userMessage)
        this.props.notification(
          err.body &&
          (err.body.userMessage || err.body.developerMessage || 'Error'),
          'error'
        )
        throw err
      }

      handleRefreshAward = () => {
        const { match, awardId } = this.props
        const { params } = match || {}
        const id = get(params, 'awardId') || awardId

        id && this.props.fetchAward(id)
      }

      notifyBlockedAward = award => {
        const { awards } = this.props
        const currAward = award || this.getCurrentAward(awards)

        this.setState({ blockedNotified: true })

        if (get(currAward, 'missingParentalConsent')) {
          this.notifyMissingParentalConsent(currAward)
        } else if (get(currAward, 'missingPayment')) {
          this.notifyMissingPayment(currAward)
        }
      }

      notifyMissingPayment = award => {
        const { intl } = this.props
        const title = intl.formatMessage({
          id: 'label.payment_not_completed',
          defaultMessage: 'Payment not completed'
        })
        const desc = intl.formatMessage({
          id: 'label.payment_not_successful_text',
          defaultMessage: 'As you have not successfully completed the payment of the award ' +
            'you will shortly be redirected to the Payment Gateway to make ' +
            'payment'
        })
        const buttonLabel = intl.formatMessage({
          id: 'button.pay_now',
          defaultMessage: 'Pay Now'
        })
        const paymentType = get(
          award,
          'participantRegistration.awardPayment.originPaymentType.value'
        )
        const authCode = get(
          award,
          'participantRegistration.onlinePaymentAuthorizationCode'
        )

        if (!authCode) {
          this.props.notification(
            'Cannot fetch Online Payment Authorization Code from API',
            {
              status: 'error'
            })
        } else {
          const callback = () => {
            authCode &&
            paymentType === PAYMENT_TYPES.online.id &&
            this.props.push(`${configFile.publicPath}/mpg-init/${authCode}`)

            authCode &&
            paymentType === PAYMENT_TYPES.payPal.id &&
            this.props.push(`${configFile.publicPath}/paypal-init/${authCode}`)
          }

          this.props.notification(desc, { title, status: 'info', buttonLabel, callback })
        }
      }

      notifyMissingParentalConsent = () => {
        const { intl } = this.props
        const desc = intl.formatMessage({
          id: 'label.registration_pending_parental_consent',
          defaultMessage: 'Your registration is pending Guardian / Parent consent'
        })

        this.props.notification(desc, { status: 'info' })
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            currentAward={this.getCurrentAward(this.props.awards)}
            onStartNewLevel={this.handleStartNewLevel}
            onSendLeaderRequest={this.handleSendLeaderRequest}
            onUploadAwardFile={this.handleUploadAwardFiles}
            onDeleteAwardFile={this.handleDeleteAwardFile}
            notifyBlockedAward={this.notifyBlockedAward}
          />
        )
      }
    }
    return enhance(apiAwardsDashboard)
  }
}

export default decorator
